import { Security } from "@fartherfinance/frontend/api/SecurityMaster/requests/Types";

const displayTitleFromSecurity = (security?: Security): string => {
  const ticker = security?.identifiers.find(
    (s) => s.registrar === "TICKER"
  )?.identifier;

  const cusip = security?.identifiers.find(
    (s) => s.registrar === "CUSIP"
  )?.identifier;

  const name = security?.name;

  const description = security?.description;

  return ticker || cusip || name || description || "N/A";
};

export default displayTitleFromSecurity;
